/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Source_LabelInputs */

const en_gc_guides_source_label = /** @type {(inputs: Gc_Guides_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Independent guide for the official v0.7.0 release.`)
};

const zh_gc_guides_source_label = /** @type {(inputs: Gc_Guides_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于官方 v0.7.0 版本的独立指南。`)
};

/**
* | output |
* | --- |
* | "Independent guide for the official v0.7.0 release." |
*
* @param {Gc_Guides_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_source_label = /** @type {((inputs?: Gc_Guides_Source_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Source_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_source_label(inputs)
	return zh_gc_guides_source_label(inputs)
});
export { gc_guides_source_label as "gc.guides.source_label" }